import { FeatureModuleEnum, JurisdictionsEnum } from '@libs/backend-common';
import { useEnabledFeatures } from './useEnabledFeatures';
import { useJurisdictionDetector } from './useJurisdictionDetector';

export const usePageNameDetector = () => {
  const { checkFeature } = useEnabledFeatures();

  const { currentJurisdiction } = useJurisdictionDetector();
  const isUaJurisdiction = currentJurisdiction === JurisdictionsEnum.UA;

  const PAGENAMES = [
    {
      name: isUaJurisdiction ? 'swap_colored_title' : 'common_dashboard',
      path: '/',
    },
    { name: 'dashboard_buy', path: '/buy' },
    { name: 'dashboard_sell', path: '/sell' },
    { name: 'dashboard_deposit_fill', path: '/deposit' },
    { name: 'wallet_action_convert', path: '/convert/BUY' },
    { name: '', path: '/feedback' },
    { name: 'wallet_action_convert', path: '/convert/SELL' },
    { name: 'dashboard_withdraw', path: '/withdraw' },
    { name: 'account_info_title', path: '/account-information/personal' },
    { name: 'account_info_title', path: '/account-information/security' },
    { name: 'account_info_title', path: '/account-information/address-book' },
    {
      name: 'account_info_title',
      path: '/account-information/notifications',
    },
    { name: 'common_pnl_full', path: '/pnl' },
    { name: 'common_referrals', path: '/referrals' },
    { name: 'common_loyalty', path: '/loyalty' },
    { name: 'common_wallet', path: '/wallet' },
    { name: 'common_market', path: '/marketplace' },
    { name: 'common_transactions', path: '/transactions' },

    { name: 'common_crexswap', path: '/swap-task-details' },
    { name: 'common_crexswap', path: '/swap-details' },
    { name: 'common_commission_fees', path: '/dashboard-fees' },
    { name: 'common_help', path: '/support-info/general' },
    { name: 'common_help', path: '/support-info/deposit-methods' },
    { name: 'common_help', path: '/support-info/withdraw-methods' },
  ];

  const isStakingAvailable = checkFeature(FeatureModuleEnum.STAKING);

  if (isStakingAvailable.isAvailable) {
    PAGENAMES.push({ name: 'common_staking', path: '/staking' });
  }
  const pathname = window.location.pathname;

  const sortedPages = [...PAGENAMES].sort(
    (a, b) => b.path.length - a.path.length
  );
  const page = sortedPages.find((page) => pathname.startsWith(page.path));

  return page ? page.name : '';
};
